import "./instrument"; // MUST be first — initializes Sentry before any app code
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import { reactErrorHandler } from "@sentry/react";

const root = ReactDOM.createRoot(document.getElementById("root"), {
  // React 19 — forward all error types to Sentry
  onUncaughtError: reactErrorHandler(),
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
});

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
